module.exports = __webpack_public_path__ + "static/media/activity-icon.bd58b9bf.svg";